module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('transition-group', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    key: "cguStore",
    staticClass: "modal-mask",
    attrs: {
      "id": "brand"
    }
  }, [_c('div', {
    staticClass: "modal-wrapper _modalWrapper_"
  }, [_c('div', {
    staticClass: "modal-container flexContainer"
  }, [_c('div', {
    staticClass: "modalBody"
  }, [(_vm.getCguStatus) ? _c('img', {
    staticClass: "cross fright abs pointer",
    attrs: {
      "src": require("../../assets/croix.png"),
      "width": "20",
      "height": "20",
      "alt": ""
    },
    on: {
      "click": _vm.close
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modalContent"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loader
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t("cguModal.title")))]), _vm._v(" "), _c('p', {
    directives: [{
      name: "html-safe",
      rawName: "v-html-safe",
      value: (_vm.cguContent[_vm.$t('trad')].value),
      expression: "cguContent[$t('trad')].value"
    }],
    staticClass: "cguContent"
  }), _vm._v(" "), (!_vm.getCguStatus) ? _c('div', {
    staticClass: "buttonChoices txtRight"
  }, [_c('button', {
    staticClass: "btn btn-exp",
    on: {
      "click": _vm.acceptCgu
    }
  }, [_vm._v(_vm._s(_vm.$t("cguModal.acceptButton")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-exp",
    on: {
      "click": _vm.refuseCgu
    }
  }, [_vm._v(_vm._s(_vm.$t("cguModal.refuseButton")))])]) : _vm._e()], 1)])])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0de700f5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CguModal/CguModal.vue
// module id = 3013
// module chunks = 0